
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/area/[slug]",
      function () {
        return require("private-next-pages/area/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/area/[slug]"])
      });
    }
  